import { render, staticRenderFns } from "./GroupsMenu.vue?vue&type=template&id=35195072&scoped=true&"
import script from "./GroupsMenu.vue?vue&type=script&lang=js&"
export * from "./GroupsMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupsMenu.vue?vue&type=style&index=0&id=35195072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35195072",
  null
  
)

export default component.exports